<template>
  <div>
    <div class="dashboard-header oil">
    <h5 class="no-margin-top">Alerts</h5>
  </div>

    <div v-if="init">
      <div class="col s12">Loading data</div>
    </div>
    <div v-else-if="init === false && oilIncidents.length === 0">
      <div class="col s12">There is no data to display</div>
    </div>
    <div v-else>
      <table class="noselect alarm-list-table striped highlight">
        <thead>
          <tr class="clickable">
            <th v-show="columns.date.visible" @click="toggleSort('Dt')">{{ $t('views.alarmlist.date') }}
              <i v-show="sortOrder.column === 'Dt' && sortOrder.direction === 'desc'" class="material-icons sort-arrow">arrow_downward</i>
              <i v-show="sortOrder.column === 'Dt' && sortOrder.direction === 'asc'" class="material-icons sort-arrow">arrow_upward</i>
            </th>
            <th v-show="columns.severity.visible" @click="toggleSort('SeverityID')">{{ $t('views.alarmlist.severity') }}
              <i v-show="sortOrder.column === 'SeverityID' && sortOrder.direction === 'desc'" class="material-icons sort-arrow">arrow_downward</i>
              <i v-show="sortOrder.column === 'SeverityID' && sortOrder.direction === 'asc'" class="material-icons sort-arrow">arrow_upward</i>
            </th>
            <th v-show="columns.path.visible" @click="toggleSort('Type')" class="min-width-type">Type
              <i v-show="sortOrder.column === 'Type' && sortOrder.direction === 'desc'" class="material-icons sort-arrow">arrow_downward</i>
              <i v-show="sortOrder.column === 'Type' && sortOrder.direction === 'asc'" class="material-icons sort-arrow">arrow_upward</i>
            </th>
            <th v-show="columns.path.visible" @click="toggleSort('RailObjectName')"> {{ $t('views.alarmlist.path') }}
              <i v-show="sortOrder.column === 'RailObjectName' && sortOrder.direction === 'desc'" class="material-icons sort-arrow">arrow_downward</i>
              <i v-show="sortOrder.column === 'RailObjectName' && sortOrder.direction === 'asc'" class="material-icons sort-arrow">arrow_upward</i>
            </th>
          </tr>
        </thead>

        <tbody>
          <tr class="clickable" v-for="(oil, index) in sortedOilList.slice(listIndex*itemsPerPage, (listIndex*itemsPerPage)+itemsPerPage)" v-bind:key="index" v-on:click="showDetail(getRailObjectById(oil.RailObjectID), oil)">
            <td  class="alarm-list-datetime">{{ oil.Dt }}</td>

            <td class="alarm-list-status warning-text" v-if="oil.SeverityID === 2"><i class="material-icons">error</i></td>
            <td class="alarm-list-status alarm-text" v-if="oil.SeverityID === 3"><i class="material-icons">warning</i></td>

            <td class="alarm-list-switch">{{ getTypeOfObject(oil) }}</td>
            <td class="alarm-list-switch"> {{ setPath(oil.RailObjectID) }}</td>
          </tr>
        </tbody>
      </table>

      <div class="noselect paging">
        <span class="buttons right">
          <a class="btn-flat" :disabled="listIndex === 0">
            <i class="material-icons" v-on:click="previousPage()">chevron_left</i>
          </a>
          <a class="btn-flat" :disabled="listIndex === parseInt(sortedOilList.length/itemsPerPage)">
            <i class="material-icons" v-on:click="nextPage()">chevron_right</i>
          </a>
        </span>

        <span class="page-number">
          <span class="right">{{sortedOilList.length}}</span>
          <span class="right">of</span>
          <span class="right">{{(listIndex*itemsPerPage)+1}}-{{ Math.min((listIndex * itemsPerPage) + itemsPerPage,sortedOilList.length)}}</span>
        </span>

        <span class="page-info right">
          <span>{{ $t('views.alarmlist.rowsperpage') }}: {{itemsPerPage}}</span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import IncidentsApi from '../../services/api/IncidentsApi'
import _ from 'lodash'
import DepartmentService from '../../services/DepartmentService'
import RegionService from '../../services/RegionService'
import ComplexService from '../../services/ComplexService'
import RailObjectService from '../../services/RailObjectService'
import Router from '../../router/index'

export default {
  name: 'oilsensorlist',
  computed: {
    sortedOilList: function () {
      if (this.oilIncidents.length > 0) {
        return _.orderBy(this.oilIncidents, [this.sortOrder.column], [this.sortOrder.direction])
      } else {
        return []
      }
    }
  },
  data () {
    return {
      oilIncidents: [],
      polling: null,
      init: true,
      listIndex: 0,
      itemsPerPage: 10,
      columns: {'date': {visible: true, sort: 'desc'}, 'severity': {visible: true, sort: null}, 'objecttype': {visible: true, sort: null}, 'path': {visible: true, sort: null}},
      sortOrder: {
        column: 'Dt',
        direction: 'desc'
      }
    }
  },
  created: function () {
    this.pollData()
  },
  mounted: function () {
    this.get()
  },
  beforeDestroy: function () {
    clearInterval(this.polling)
  },
  methods: {
    getTypeOfObject: function (oilObject) {
      // Very ugly code, should be fixed
      var description = oilObject.Description

      if (typeof description === 'string') {
        description = description.replace('"', '')
        description = description.replace('<Alarms><', '')
        description = description.replace('/></Alarms>', '')

        var code = 0

        if (description.split(' ') !== undefined && description.split(' ').length > 0) {
          if (description.split(' ')[1].split('=') !== undefined && description.split(' ')[1].split('=').length > 0) {
            code = description.split(' ')[1].split('=')[1].replace('"', '')
          }
        }

        if (code > 800000) {
          return 'DI'
        } else {
          return ''
        }
      } else {
        return ''
      }
    },
    toggleSort: function (column) {
      this.sortOrder.column = column
      if (this.sortOrder.direction === 'desc') {
        this.sortOrder.direction = 'asc'
      } else {
        this.sortOrder.direction = 'desc'
      }
    },
    getRailObjectById: function (railObjectid) {
      return RailObjectService.getRailObjectByRailObjectId(railObjectid)
      // return this.railobjects.find(e => e.RailObjectId === railObjectid)
    },
    showDetail: function (railObject, oilIncident) {
      if (railObject.DataSourceCode === 'WID') {
        var railObjectChildren = RailObjectService.getRailObjectChildrenByParentId(railObject.RailObjectId)
        var railObjectChild = null
        switch (oilIncident.SeverityID) {
          case 2:
            railObjectChild = railObjectChildren.find(ro => ro.Name === 'Oil Low')
            break
          case 3:
            railObjectChild = railObjectChildren.find(ro => ro.Name === 'Oil Low Low')
            break
        }
        Router.push({
          name: 'Switch',
          params: {
            id: railObject.RailObjectId,
            motorId: railObjectChild ? railObjectChild.RailObjectId : null
          },
          props: true
        })
      }
      if (railObject.DataSourceCode === 'ATD') {
        Router.push({
          name: 'AxleCounter',
          params: {
            railobjectid: railObject.RailObjectId
            // passedMeasurementId: railObject.LastMeasurementId
          }
        })
      }
    },
    setPath: function (railobjectId) {
      var ro = this.getRailObjectById(railobjectId)
      var reg = RegionService.getRegionByRegionId(ro.RegionId)
      var dep = DepartmentService.getDepartmentByDepartmentId(ro.DepartmentId)
      var com = ComplexService.getComplexByComplexId(ro.ComplexId)
      var path = reg.Name + ' \\ ' + dep.Name + ' \\ ' + com.Name + ' \\ ' + ro.Name
      return path
    },
    nextPage: function () {
      this.listIndex++
    },
    previousPage: function () {
      this.listIndex--
    },
    pollData: function () {
      this.polling = setInterval(() => {
        this.get()
      }, 37579) // set it on a prime number to interfere less with other timed queries
    },
    get: async function () {
      await IncidentsApi.getIncidents().then(response => {
        this.oilIncidents = response.data
        this.init = false
      }).catch(error => {
        console.log(error)
        this.init = false
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.min-width-type {
  min-width: 100px;
}

.oil {
  padding: 5px 5px;
  text-align: left;
}

.alarm-list-content > .title {
  padding-top: 16px;
  padding-left: 22px;
}

.alarm-list-content .filter-content {
  position: relative;
  padding-left: 22px;
  padding-right: 22px;
  width: 100%;
}

.filter-content > .title {
  margin-top: 20px;
  font-size: 14px;
  font-family:Roboto;
  font-weight: 600;
  font-style: normal;
  line-height: normal;
}

.filters tr {
  border-bottom: none;
}

.filters td span {
  color: rgba(0, 0, 0, 0.87);
}

.filters td:first-child {
  color: rgba(0, 0, 0, 0.4);
}

.alarm-list-table {
  position: relative;
}

.alarm-list-table thead tr {
  border-top: 1px solid rgba(0, 0, 0, 0.4);
  border-bottom: 1px solid rgba(0, 0, 0, 0.4);
}

.alarm-list-table th, .alarm-list-table td {
  padding: 5px 5px;
  text-align: left;
}

.alarm-list-table .material-icons {
  font-size: 20px;
}

.paging {
  height: 50px;
  width: 100%;
  left: 0px;
  line-height: 50px;
  position: relative;
  border-top: 1px solid rgba(0, 0, 0, 0.4);
}

.paging .page-number {
  margin-right: 30px;
}

.paging .page-number span {
  padding-right: 5px;
}

.paging .page-info {
  margin-right: 40px;
}

.paging .buttons .btn-flat[disabled] {
  background-color: #fff !important;
}

.filter-menu {
  position: relative;
  z-index: 100;
}

.filter-menu > div {
  top: 28px;
  right: 10px;
  width: 250px;
  position: absolute;
}

.sort-arrow {
  position: absolute;
  margin-left: 5px;
}

.alarm-list-table th {
  white-space: nowrap;
}

.alarm-list-table th > i {
  position: relative;
}

.filter-text {
  margin-left: 22px;
  color: rgba(0, 0, 0, 0.4);
  font-size: 14px;
}

.column-date {
  width:140px;
}
</style>



// WEBPACK FOOTER //
// src/pages/dashboard/_OilSensorList.vue